const compareBuild = require('./compare-build')
const sort = (list, loose) => list.sort((a, b) => compareBuild(a, b, loose))
module.exports = sort



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/node_modules/semver/functions/sort.js
// module id = 1439
// module chunks = 21